const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const OpsSchool = require("./vault/OpsSchool");
const Dropdown = require("./SchoolDropdown");
const URLMake = require("../../shared/URLMake");
const {getDisplayedGradeLabel} = require("../../shared/SchoolUtil");
const Link = require("../core/view/Link");
const ClassesUtil = require("./util/ClassesUtil");
const DefaultSettings = require("./DefaultSettings");
const EditPencil = require("../office/EditPencil");
const InfoIcon = require("../office/InfoIcon");
const CopyTable = require("./data/CopyTable");

const styles = require("./styles/AccountBodyHeader.css");

module.exports = createReactClass({
	displayName: "AccountBodyHeader",

	propTypes: {
		user: PT.object.isRequired,
		tab: PT.string,
		pageData: PT.object,
		schoolState: PT.object.isRequired,
		updateFilter: PT.func.isRequired,
		availableGrades: PT.array,
		availableYears: PT.array,
		availableDisplayedGrades: PT.array,
		filters: PT.object,
		showModal: PT.func,
		shouldShowFilters: PT.bool,
	},

	getInitialState: function() {
		return {
			status: null,
			shouldShowFilters: true,
		};
	},

	// This is to filter list of classes and students by class grade level
	makeDisplayedGradeFilter: function() {
		const {filters, updateFilter, availableDisplayedGrades} = this.props;
		const {displayedGrade} = filters;

		const grades = availableDisplayedGrades;

		return (
			<Dropdown
				className={styles.gradeFilter}
				options={_.zipObject(
					grades,
					grades.map(g => getDisplayedGradeLabel(g))
				)}
				defaultOption="All Grades"
				initialValue={
					displayedGrade != null ? displayedGrade.toString() : undefined
				}
				updateSelection={val => updateFilter("displayedGradeFilter", val)}
				style="rectangle"
			/>
		);
	},

	makeYearFilter: function() {
		const {filters, updateFilter, availableYears} = this.props;
		const {year} = filters;
		const years = availableYears;
		const getYearText = yr => yr - 1 + "-" + yr;
		return (
			<Dropdown
				className={styles.yearFilter}
				options={_.zipObject(
					years,
					years.map(y => getYearText(y))
				)}
				orderOptions="desc"
				initialValue={year && year.toString()}
				updateSelection={val => updateFilter("yearFilter", val)}
				style="rectangle"
			/>
		);
	},

	makeTitle: function({scope, scopeInfo, canEdit, isActive, classID, userID}) {
		const propMap = {
			school: {icon: "g", data: {schoolID: scopeInfo.id, type: "displayName"}},
			class: {icon: "Q", data: {classID: scopeInfo.id, type: "displayName"}},
			student: {icon: "G", data: {userID: scopeInfo.id, type: "name"}},
			staff: {icon: "F", data: {userID: scopeInfo.id, type: "name"}},
			purchase: {icon: "", data: {type: "displayName"}},
		};
		const isUser = scope === "student" || scope === "staff";
		const props = propMap[scope];
		const editEl =
			canEdit && isActive ? (
				<EditPencil
					onClick={() => this.props.showModal("updateInfo", props.data)}
					className={styles.pencil}
				/>
			) : null;
		let linkToReport;
		if (scope === "class") {
			linkToReport =
				!canEdit && !isActive ? null : (
					<Link
						to={URLMake.forClassReport(scopeInfo.id)}
						className={styles.goToReport}
						isNewTab={true}
					>
						<span className={styles.bao}>h</span>
						{"Go to Report"}
					</Link>
				);
		} else if (scope === "student") {
			linkToReport = !canEdit ? null : (
				<Link
					to={URLMake.forStudentReport(scopeInfo.id)}
					className={styles.goToReport}
					isNewTab={true}
				>
					<span className={styles.bao}>h</span>
					{"Go to Report"}
				</Link>
			);
		}
		return (
			<div className={styles.name}>
				{editEl}
				<span className={styles.bao}>{props.icon}</span>
				<span className={styles.titleText}>
					{isUser ? ClassesUtil.getUserName(scopeInfo) : scopeInfo.displayName}
				</span>
				{linkToReport}
			</div>
		);
	},

	makeFilters: function() {
		const {
			availableYears,
			tab,
			pageData,
			availableDisplayedGrades,
		} = this.props;
		const {userID, classID} = pageData;
		const showGradeFilter =
			!userID && !classID && (tab === "classes" || tab === "students");
		const showYearFilter = showGradeFilter;
		const displayedGradeFilter =
			showGradeFilter && availableDisplayedGrades.length > 1
				? this.makeDisplayedGradeFilter()
				: null;

		let yearFilter;
		if (showYearFilter) {
			if (availableYears.length > 1) {
				yearFilter = this.makeYearFilter();
			} else if (availableYears.length) {
				yearFilter = (
					<div className={styles.singleYear}>
						{availableYears[0]
							? availableYears[0] - 1 + "-" + availableYears[0]
							: ""}
					</div>
				);
			}
		}

		return yearFilter || displayedGradeFilter ? (
			<div className={styles.filters}>
				{yearFilter}
				{displayedGradeFilter}
			</div>
		) : null;
	},

	makeTabs: function(user) {
		const {pageData, tab, schoolState} = this.props;
		const {accounts} = schoolState;
		const {userID, classID, schoolID} = pageData || {};
		const isSingleSchool = _.get(accounts, "purchase.isSingleSchool");

		const getTabClass = tabType =>
			tab === tabType ? styles.selectedTab : styles.tab;

		let innerTabs;
		const viewableSchools = OpsSchool.getViewableSchools(
			schoolState,
			user.userID
		);
		if (!classID && !userID) {
			const isPurchaseAdmin = OpsSchool.isPurchaseAdmin(
				schoolState,
				user.userID
			);
			const schoolTab =
				schoolID ||
				isSingleSchool ||
				(!viewableSchools.length && !isPurchaseAdmin) ? null : (
					<Link to={URLMake.forSchool("accounts", "schools", pageData)}>
						<div className={getTabClass("schools")}>
							<span className={styles.bao}>g</span>Schools
						</div>
					</Link>
				);

			let subscriptionTab;
			let staffTab;
			if (isPurchaseAdmin && ((schoolID && isSingleSchool) || !schoolID)) {
				subscriptionTab = (
					<Link to={URLMake.forSchool("accounts", "subscription", pageData)}>
						<div className={getTabClass("subscription")}>
							<span className={styles.bao}>0</span>Subscription
						</div>
					</Link>
				);
			}

			if (
				OpsSchool.getPartiallyAdminnedStaff(schoolState, user.userID).length
			) {
				staffTab = (
					<Link to={URLMake.forSchool("accounts", "staff", pageData)}>
						<div className={getTabClass("staff")}>
							<span className={styles.bao}>F</span>Staff
						</div>
					</Link>
				);
			}

			innerTabs = (
				<div className={styles.buttons}>
					{subscriptionTab}
					{schoolTab}
					{staffTab}
					<Link to={URLMake.forSchool("accounts", "classes", pageData)}>
						<div className={getTabClass("classes")}>
							<span className={styles.bao}>Q</span>Classes
						</div>
					</Link>
					<Link to={URLMake.forSchool("accounts", "students", pageData)}>
						<div className={getTabClass("students")}>
							<span className={styles.bao}>G</span>Students
						</div>
					</Link>
				</div>
			);
		}
		return innerTabs;
	},

	render: function() {
		const {pageData, schoolState, user} = this.props;
		const {userID, classID, schoolID} = pageData || {};
		const {accounts} = schoolState;

		//The requesting user (current logged in user)
		const userInfo = OpsSchool.getUser(schoolState, user.userID);

		let isActive = OpsSchool.isPurchaseActive(schoolState);
		let parentIsActive = isActive;
		let year;
		let scope = "purchase";
		let settings;
		let extraEl;
		let parentSettings;
		let scopeInfo = _.get(schoolState, "accounts.purchase");
		let role = userInfo.current.adminPurchase ? "purchaseAdmin" : null;
		let canEdit = role === "purchaseAdmin";
		let canEditSettings = canEdit;

		const purchaseSettings = OpsSchool.getSettingsForPurchase(schoolState);
		const purchaseYear = OpsSchool.getPurchaseYear(schoolState);
		const isSingleSchool = _.get(
			schoolState,
			"accounts.purchase.isSingleSchool"
		);
		const isPurchaseActive = OpsSchool.isPurchaseActive(schoolState);

		if (schoolID) {
			scope = "school";
			scopeInfo = _.get(accounts, ["schools", schoolID], {});
			isActive = OpsSchool.isSchoolActive(schoolState, schoolID);
			role = OpsSchool.getBestRoleForSchool(schoolState, user.userID, schoolID);
			canEdit = role === "purchaseAdmin" || role === "schoolAdmin";

			settings = OpsSchool.getSettingsForSchool(schoolState, schoolID);
			parentSettings = purchaseSettings;
		} else if (classID) {
			scope = "class";
			scopeInfo = _.get(accounts, ["classes", classID], {});
			const classSchool = OpsSchool.getSchoolForClass(schoolState, classID);
			isActive = OpsSchool.isClassActive(schoolState, classID);
			parentIsActive = OpsSchool.isParentOfClassActive(schoolState, classID);
			year = scopeInfo.year;
			role = OpsSchool.getBestRoleForClass(schoolState, user.userID, classID);
			canEdit = role === "purchaseAdmin" || role === "schoolAdmin";
			canEditSettings = !!role;

			parentSettings = OpsSchool.getSettingsForSchool(
				schoolState,
				classSchool.id
			);
			settings = OpsSchool.getSettingsForClass(schoolState, classID);
			settings.grade = scopeInfo.gradeID;
			settings.displayedGrade = scopeInfo.displayedGrade;
			settings.beastLock = _.get(schoolState, [
				"accounts",
				"classes",
				classID,
				"beastLock",
			]);
		} else if (userID) {
			const isStaff = OpsSchool.isStaff(schoolState, userID);
			scope = isStaff ? "staff" : "student";
			scopeInfo = OpsSchool.getUser(schoolState, userID);
			isActive = isStaff
				? isActive && scopeInfo.active
				: OpsSchool.isStudentActive(schoolState, userID);
			role = isStaff
				? OpsSchool.getBestRoleForStaff(schoolState, user.userID, userID)
				: OpsSchool.getBestRoleForStudent(schoolState, user.userID, userID);
			canEdit = isStaff
				? role === "purchaseAdmin" || role === "schoolAdmin"
				: !!role;

			const studentClass = OpsSchool.getClassForStudent(schoolState, userID);
			parentIsActive = isStaff ? isActive : studentClass.active;
			year = isStaff ? null : studentClass.year;
		} else {
			settings = purchaseSettings;
			const domain = _.get(accounts, "purchase.domain");
			extraEl = domain ? (
				<div className={styles.domain}>
					<div>Sign In URL:</div>
					<div className={styles.domainName}>
						{`BeastAcademy.com/signin/${domain}`}
					</div>
				</div>
			) : null;
		}

		const purchaseID = _.get(schoolState, "accounts.purchase.id");
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);

		const titleEl = this.makeTitle({
			scope,
			scopeInfo,
			isActive,
			canEdit: canEdit && !isAcademy,
			classID,
			userID,
		});
		const settingsEl = settings ? (
			<DefaultSettings
				settings={settings}
				schoolID={schoolID}
				classID={classID}
				purchaseID={purchaseID}
				parentSettings={parentSettings || {}}
				isSingleSchool={_.get(schoolState, "accounts.purchase.isSingleSchool")}
				canEdit={(canEdit || canEditSettings) && isActive && !isAcademy}
				role={role}
			/>
		) : null;

		let schoolAdminsEl;
		// Show school admins if they can't see staff tab
		if (
			schoolID &&
			!OpsSchool.getPartiallyAdminnedStaff(schoolState, user.userID).length
		) {
			const schoolAdmins = isSingleSchool
				? OpsSchool.getPurchaseAdmins(schoolState)
				: OpsSchool.getAdminsForSchool(schoolState, schoolID);
			if (schoolAdmins.length) {
				let adminInfo;
				if (schoolAdmins.length > 1) {
					const adminList = schoolAdmins.map(sa => {
						return (
							<tr key={sa.id} className={styles.adminRow}>
								<td>{`${sa.firstName} ${sa.lastName}`}</td>
								<td>{`${sa.email}`}</td>
							</tr>
						);
					});
					const iconEl = <span>+{schoolAdmins.length - 1}</span>;
					adminInfo = (
						<InfoIcon
							text={
								<table className={styles.adminTable}>
									<tbody>{adminList}</tbody>
								</table>
							}
							className={styles.adminInfo}
							title="School Administrators"
							isModal={true}
							iconAsElement={iconEl}
						/>
					);
				}
				const sa = schoolAdmins[0];
				schoolAdminsEl = (
					<div className={styles.adminsOuter}>
						<div className={styles.adminLabel}>School Admins</div>
						<div className={styles.firstAdmin}>
							{`${sa.firstName} ${sa.lastName}: ${sa.email}`} {adminInfo}
						</div>
					</div>
				);
			}
		}
		const inactiveEl = isActive ? null : (
			<div className={styles.inactiveOuter}>
				<InfoIcon
					className={styles.info}
					text={CopyTable.getInactiveCopy(
						parentIsActive,
						scopeInfo.active,
						scope,
						year && year < purchaseYear,
						isPurchaseActive
					)}
					isModal={true}
				/>
				<span className={styles.inactive}>inactive</span>
			</div>
		);

		const rightEl = (
			<div className={styles.right}>
				{year ? `${year - 1}-${year}` : null}
				{inactiveEl}
				{extraEl}
			</div>
		);
		const shownFilters = this.props.shouldShowFilters
			? this.makeFilters()
			: null;
		return (
			<div className={styles.main}>
				<div className={styles.top}>
					<div className={styles.titleOuter}>
						{titleEl}
						{rightEl}
					</div>
					<div className={styles.settingsRow}>
						{settingsEl}
						{schoolAdminsEl}
					</div>
					{this.makeTabs(user)}
				</div>
				{shownFilters}
			</div>
		);
	},
});
